import * as React from 'react';
import SecondaryMenu from '../shared/SecondaryMenu';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import '../../style/UserStyleSheet.css';
import api from '../../store/api';
import { useState } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useHistory } from "react-router-dom";
import { TextField } from '@material-ui/core';
import throttle from 'lodash/throttle';
import Switch from '@material-ui/core/Switch';
import SignOutUserDialog from '../shared/SignOutUserDialog';
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';
import { FlameIcon } from '../../assets/iconComponents/Icons';
import eventNames from '../../store/signalr/eventNames';
import { addTaskForEvent, removeTaskForEvent } from '../../store/signalr/tasksForEvents';

interface User {
    employeeId: string;
    userId: string,
    userCombinedName: string,
    userProfileName: string,
    userCustomerName: string,
    userLocationName: string,
    userWardName: string,
    hasVehicleSession: Boolean,
    lastLoginDate: string | Date | number,
    eventCounter: null | number,
    userProfileId: string;
};
interface Userprofilemanage {
    userProfileManageUserId: string;
    userProfileId: string;
    userId: string,
    manageUserProfileId: string,
    createdBy: string,
    createdOn: Date,
    modifiedBy: string,
    modifiedOn: Date,
};
const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: 40,
        marginRight: 40,
    },
    heading: {
        fontSize: 38,
        fontWeight: 900,
        padding: theme.spacing(5, 0, 1, 0),
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
        backgroundColor: '#ECECEC',
        height: 30
    },
    formBtn: {
        width: '100px',
    },
    gridStyle: {
        padding: theme.spacing(5, 0, 5, 0)
    },
    table: {
        minWidth: 650,
        tableLayout:'fixed'
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2, 0, 0, 50),
        },
    },
    searchTextBox: {
        '& .MuiOutlinedInput-adornedStart': {
            paddingLeft: 0,
            top:4
        },
        height: 44,
    },
    textFieldInput: {
        backgroundColor: '#ECECEC',
        color: 'black',
        height: '44px',
        border: 'none',
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    tableRow: {
        cursor: 'pointer'
    },
    signoutBtn: {
        width: 90,
        padding: '6px 8px',
        backgroundColor: '#0049a3',
        borderRadius:5,
        color: '#FFF',
        textAlign:'center'
    },
    tableCell: {
        paddingLeft: 25,
        paddingRight:10,
        textOverflow: 'ellipsis',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    },
    signOutTableCell: {
        paddingLeft: 10,
        paddingRight: 5,
    }

}));

const headCells = [
    { id: 'userCombinedName', numeric: false, disablePadding: true, label: 'Name', width:'15%' },
    { id: 'userProfileName', numeric: false, disablePadding: false, label: 'Profile',width:'13%' },
    { id: 'userCustomerName', numeric: false, disablePadding: false, label: 'Customer',width:'13%' },
    { id: 'userLocationName', numeric: false, disablePadding: false, label: 'Location', width:'14%' },
    { id: 'userWardName', numeric: false, disablePadding: false, label: 'Ward', width: '10%' },
    { id: 'lastLogin', numeric: false, disablePadding: false, label: 'Last Login', width: '13%' },
    { id: 'activity', numeric: false, disablePadding: false, label: 'Activity', width: '13%' },
    { id: 'action', numeric: false, disablePadding: false, label: '', width:'9%' },
];

const ActivityIcon = (events: null | number) => {

    if (!events || (events >= 0 && events <= 10)) {
        return;
    }

    if (events > 10 && events <= 100) {
        return (
            <div style={{display: 'flex'}} >
                <FlameIcon height={30} width={30} />
            </div>
        )
    }
    if (events > 100 && events <= 1000) {
        return (
            <div style={{ display: 'flex' }} >
                <FlameIcon height={30} width={30} />
                <FlameIcon height={30} width={30} />
            </div>
        )
    }
    if (events > 1000 ) {
        return (
            <div style={{ display: 'flex' }} >
                <FlameIcon height={30} width={30} />
                <FlameIcon height={30} width={30} />
                <FlameIcon height={30} width={30} />
            </div>
        )
    }
}

const componentTaskId = "viewUsersWidget";

function ViewUsersWidget(): JSX.Element {
    const classes = useStyles();
    const [userList, setUserList] = useState<User[]>([]);
    const [UserProfileManage, setUserProfileManage] = useState<Userprofilemanage[]>([]);
    const [order, setOrder] = React.useState('asc');

    const [orderBy, setOrderBy] = React.useState('userCombinedName');

    const [selected, setSelected] = React.useState('');
    const [page, setPage] = React.useState(0);

    const [recordCount, setRecordCount] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchText, setSearchText] = React.useState('');
    const [showAllUsers, setShowAllUsers] = React.useState(false);

    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const refOrder = React.useRef('asc');
    const refOrderBy = React.useRef('userCombinedName');
    const refSearchText = React.useRef('');
    const refPage = React.useRef(0);
    const [signoutDialog, setSignoutDialog] = useState(false);
    const [signoutUserId, setSignoutUserId] = useState('');

    const whenRefreshUsersDo = () =>  getAllUsers(refPage.current, refSearchText.current, refOrder.current, refOrderBy.current);

    React.useEffect(() => {
        addTaskForEvent(eventNames.refreshUsers, componentTaskId, whenRefreshUsersDo);
        return () => {
            removeTaskForEvent(eventNames.refreshUsers, componentTaskId);
        }
    }, [whenRefreshUsersDo]);

    React.useEffect(() => {
        setPage(0);
        if (!signoutDialog) {
            getAllUsers(1, searchText, 'asc', 'userCombinedName');
        }
    }, [showAllUsers, signoutDialog]);

    React.useEffect(() => {
        refPage.current = page;
        refSearchText.current = searchText;
        refOrder.current = order;
        refOrderBy.current = orderBy;
    }, [page, searchText, order, orderBy]);

    React.useEffect(() => {
        refPage.current = page;
        refSearchText.current = searchText;
        refOrder.current = order;
        refOrderBy.current = orderBy;
    }, [page, searchText, order, orderBy]);


    //Get All Users
    const getAllUsers = React.useMemo(() => throttle(async (updatePageNumber: any, keyword: string, sortOrder: any, sortColumn: any): Promise<void> => {

        setLoading(true);
        const _res = await api.searchUsersByName('searchstr=' + keyword + '&pagenumber=' + (updatePageNumber ? updatePageNumber : page) + '&pagesize=10&sortcolumn=' + sortColumn + '&sortdirection=' + sortOrder + `&showAll=${showAllUsers}`+`&version=`+Math.random()+Math.random()+Math.random());
        if (_res !== null && _res.data !== null && _res.data.model !== null) {
            setRecordCount(_res.data.itemsCount);
            //Removed unreachable code for issue 14 - Pagination issue
            if (_res.data.itemsCount > 0) {
                const _ress = await api.GetUserProfile('');
                const users:User[]=_res.data.model;
                const usersmanage:Userprofilemanage[]=_ress.data.model;
                const  resuult = users.filter(({ userProfileId: id1 }) => usersmanage.some(({ userProfileId: id2 }) => id2 === id1)).length;
                setUserList(_res.data.model);
                setUserProfileManage(_ress.data.model);
            } else {
                setUserList([]);
            }
        } else {
            setUserList([]);
        }
        setLoading(false);
    }, 200), [showAllUsers]);


    const editUserClick = (event: any, id: any) => {
        if (id) {
            setSelected(id);
            history.push({
                pathname: '/settings/users/edit/' + id,
            });
        }
    };

    const addUserClick = (event: any) => {
        history.push({
            pathname: '/settings/users/add'
        });
    };

    const createSortHandler = (event: any, column: any) => {
        console.log(column);
        let order_str = (orderBy == column ? (order === 'asc' ? 'desc' : 'asc') : 'asc');
        setOrder(order_str);
        setOrderBy(column);
        getAllUsers(page, searchText, order_str, column);
    };

    const handleChangePage = (event: any, newPage: any) => {
        const updatePage = newPage + 1;
        setPage(newPage);
        getAllUsers(updatePage, searchText, order, orderBy);
    };

    let filterTimeOut: NodeJS.Timeout;

    const inputChangedHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        clearTimeout(filterTimeOut);
        filterTimeOut=setTimeout(() => {
            setSearchText(e.target.value);
            searchUsers(e.target.value);
        }, 100)
    }

    const searchUsers = async (keyword: string): Promise<void> => {
        setPage(0);
        getAllUsers(1, keyword, order, orderBy);
    }

    const searchUsersByEnter = async (event: any): Promise<void> => {
        if (event.key === 'Enter') {
            await searchUsers(searchText);
        }
    }

    const CreateLoadingLine = (props: any): JSX.Element => {
        return (
            <div className={classes.loading}>
                <LinearProgress color="primary" />
            </div>
        )
    }

    const signOutUser = () => {
        const data = {"userId": signoutUserId}
        api.destroyUserVehicleSession('', data).then(res => {
            setSignoutDialog(false);
        })
    }

    const signoutClick = (e: any, userId: string) => {
        setSignoutDialog(true);
        setSignoutUserId(userId);
        e.stopPropagation();
    }

     return (
        <div style={{ display: 'flex', alignItems: 'stretch', flexGrow: 1, }}>

            <div style={{ alignSelf: 'stretch', display: 'flex' }}>
                <SecondaryMenu selectedmenu='Users' />
            </div>

            <div style={{ display: 'flex', alignSelf: 'start' }}>

                <Grid container style={loading ? {pointerEvents: "none", opacity: "0.4"} : {}}>
                    <Grid item xs={6} style={{ paddingLeft: 40 }}>
                        <div className={classes.heading}>Users</div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Switch
                                checked={!showAllUsers}
                                onChange={() => setShowAllUsers(prev => !prev)}
                                color="primary"
                            />
                            <span style={{ fontSize: 20, fontWeight: 400 }}>Hide disabled users</span>
                        </div>
                    </Grid>
                    <Grid item container xs={6} justify="flex-end" style={{ textAlign:'right',paddingTop: 40, paddingBottom: 40, paddingRight:25 }}>
                        <div style={{display:'flex',}}>
                            <TextField
                                classes={{ root: classes.searchTextBox }}
                                InputProps={{
                                    startAdornment: < InputAdornment position="end" >
                                        <SearchIcon style={{ color: "#707070" }} />
                                    </InputAdornment>
                                }}
                                variant='outlined'
                                className="searchTxt"
                                id="standard-adornment-password"
                                type="text"
                                onKeyPress={searchUsersByEnter}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => inputChangedHandler(e)}
                            />
                            <Button className="searchBtn" style={{ marginLeft: 20 }}  onClick={addUserClick} variant="contained" color="primary">Add User </Button>
                        </div>
                    </Grid>


                    <Grid container item xs={12} justify="flex-end">
                        <TableContainer>
                            <Table
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                size={dense ? 'small' : 'medium'}
                                aria-label="enhanced table"
                            >

                                <TableHead>
                                    <TableRow>
                                        {headCells.map((headCell) => (
                                            <TableCell
                                                key={headCell.id}
                                                align={headCell.numeric ? 'right' : 'left'}
                                                width={headCell.width}
                                                sortDirection={orderBy === headCell.id ? 'asc' : false}
                                                className={classes.tableCell}
                                            >
                                                <TableSortLabel
                                                    active={orderBy === headCell.id}
                                                    direction={orderBy === headCell.id ? (order === 'asc' ? 'asc' : 'desc') : undefined}
                                                    onClick={(e => createSortHandler(e, headCell.id))}>
                                                    {headCell.label}
                                                </TableSortLabel>
                                            </TableCell>
                                        ))}
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {userList.length > 0 ?
                                        userList.map((row, index) => {
                                            return (
                                                <TableRow
                                                    className={classes.tableRow}
                                                    hover
                                                    onClick={(event) => editUserClick(event, row.userId)}
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={row.userId}>
                                                    <TableCell className={classes.tableCell} component="th" scope="row">
                                                        {row.userCombinedName}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.tableCell} >{row.userProfileName}</TableCell>
                                                    <TableCell align="left" className={classes.tableCell} >{row.userCustomerName}</TableCell>
                                                    <TableCell align="left" className={classes.tableCell} >{row.userLocationName}</TableCell>
                                                    <TableCell align="left" className={classes.tableCell} >{row.userWardName}</TableCell>
                                                    <TableCell align="left" className={classes.tableCell}  >{row.lastLoginDate && formatDistanceToNowStrict( new Date(row.lastLoginDate), {unit:'day'})}</TableCell>
                                                    <TableCell align="left" className={classes.tableCell} >{ActivityIcon(row?.eventCounter)}</TableCell>
                                                    <TableCell className={classes.signOutTableCell} >{
                                                        row?.hasVehicleSession &&
                                                        <div onClick={(e) => { signoutClick(e, row.userId) }} className={classes.signoutBtn}>Sign Out</div>
                                                    }
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                        :
                                        <TableRow>
                                            <TableCell align="center" colSpan={8}>No data available</TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={recordCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                        />
                    </Grid>
                </Grid>
            </div>
            <div style={{ marginTop: 5, marginBottom: 20, }}>
                {loading ? <CreateLoadingLine /> : null}
            </div>
            <SignOutUserDialog isDialogOpen={signoutDialog} onCancel={setSignoutDialog} onClickFunc={signOutUser} popupMessage={"Do you want to signout this user?"} />
        </div>

    )
}

export default React.memo(ViewUsersWidget);